export type ModoApiLeitor = 'LOCAL' | 'EXTERNO';

export const PORTA_PUBLICA_PADRAO_ID_FACE = 4083;

export function caminhoControlId(slugTenant: string | undefined) {
  const slug = (slugTenant || '').trim().toLowerCase();
  return slug ? `api/public/tenants/${slug}/controlid` : '';
}

export function urlApiLeitor(
  modo: ModoApiLeitor | undefined,
  slugTenant: string | undefined,
  urlApiLocal?: string
) {
  const slug = (slugTenant || '').trim().toLowerCase();
  if (!slug) {
    return '';
  }
  const caminho = `/${caminhoControlId(slug)}`;
  if (modo === 'LOCAL') {
    const base = (urlApiLocal || '').trim().replace(/\/+$/, '');
    return base ? `${base}${caminho}` : '';
  }
  return `https://${slug}.jwmtecnologia.com.br${caminho}`;
}

export function ipv4Valido(ip?: string) {
  const octetos = (ip || '').trim().split('.');
  if (octetos.length !== 4) {
    return false;
  }
  return octetos.every((octeto) => {
    if (!/^\d{1,3}$/.test(octeto)) {
      return false;
    }
    const valor = Number(octeto);
    return valor >= 0 && valor <= 255;
  });
}

export function portaIdFaceValida(porta?: number) {
  return Number.isInteger(porta) && Number(porta) >= 1 && Number(porta) <= 65535;
}

export function destinoIdFaceExterno(ip?: string, porta?: number) {
  if (!ipv4Valido(ip) || !portaIdFaceValida(porta)) {
    return '';
  }
  return `${(ip || '').trim()}:${porta}`;
}

export function rotuloModoApiLeitor(modo?: ModoApiLeitor) {
  return modo === 'LOCAL' ? 'Local (rede interna)' : 'Externo (jwmtecnologia.com.br)';
}
